module.exports = __webpack_public_path__ + "static/pic02-c052a846e63f015be158148b9421d2e7.jpg";